import _defineProperty from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { memo } from 'react';
import { useDeepEffect } from '../../utilities/use-deep-effect.js';
import { useUniqueId } from '../../utilities/unique-id/hooks.js';
import { useFrame } from '../../utilities/frame/hooks.js'; // that the interface defining the props is defined in this file, not imported
// from elsewhere. This silly workaround ensures that the Props Explorer table
// is generated correctly.

var Toast = /*#__PURE__*/memo(function Toast(props) {
  var id = useUniqueId('Toast');

  var _useFrame = useFrame(),
      showToast = _useFrame.showToast,
      hideToast = _useFrame.hideToast;

  useDeepEffect(function () {
    showToast(_objectSpread({
      id: id
    }, props));
    return function () {
      hideToast({
        id: id
      });
    };
  }, [props]);
  return null;
});
export { Toast };